import React from "react";
import "./EvidenceTouchableRow.css";

/** Row for achievements / competitions / etc. Opens modal when `evidenceKeys` is non-empty. */
function EvidenceTouchableRow({ title, detail, evidenceKeys, onOpen }) {
    const hasProof = Array.isArray(evidenceKeys) && evidenceKeys.length > 0 && evidenceKeys.every(Boolean);
    const clickable = hasProof;

    return (
        <div
            className={`evidence-row ${clickable ? "evidence-row--clickable" : "evidence-row--disabled"}`}
            role={clickable ? "button" : undefined}
            tabIndex={clickable ? 0 : undefined}
            onClick={() => clickable && onOpen(evidenceKeys)}
            onKeyDown={(e) => {
                if (!clickable) return;
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onOpen(evidenceKeys);
                }
            }}
        >
            <div className="evidence-row-body">
                <h3 className="evidence-row-title">{title}</h3>
                {detail ? <p className="evidence-row-detail">{detail}</p> : null}
            </div>
            {clickable ? (
                <span className="evidence-row-badge">View</span>
            ) : (
                <span className="evidence-row-badge evidence-row-badge--muted">No scan</span>
            )}
        </div>
    );
}

export default EvidenceTouchableRow;
